export const THREE_FOURS_SHOW_MODAL = 'ThreeFoursWidget::ShowModal';
export const THREE_FOURS_HIDE_MODAL = 'ThreeFoursWidget::HideModal';
